export default {
      id: "print-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#print",
      toString: function () {
        return this.url;
      }
    }